// Models
import { RecurrenceEndType } from "../../../service/planner/enumerations/IPlannerEnumerations";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Implementation of the recurrence range
 */ export class RecurrenceRange {
    static fromResource(resource) {
        const recurrenceEndType = resource.recurrenceEndType;
        switch(recurrenceEndType){
            case RecurrenceEndType.ByDate:
                return new RecurrenceRange({
                    startDate: Temporal.Instant.from(resource.startDate),
                    recurrenceEndType: resource.recurrenceEndType,
                    endDate: Temporal.Instant.from(resource.endDate),
                    countOfInstances: null
                });
            case RecurrenceEndType.ByCount:
                return new RecurrenceRange({
                    startDate: Temporal.Instant.from(resource.startDate),
                    recurrenceEndType: resource.recurrenceEndType,
                    endDate: null,
                    countOfInstances: resource.countOfInstances
                });
            case RecurrenceEndType.EndOfPlan:
                return new RecurrenceRange({
                    startDate: Temporal.Instant.from(resource.startDate),
                    recurrenceEndType: resource.recurrenceEndType,
                    endDate: null,
                    countOfInstances: null
                });
            default:
                throw new Error(`Unsupported recurrence end type: ${recurrenceEndType}`);
        }
    }
    getClone() {
        return RecurrenceRange.fromResource(this.forSerialization());
    }
    forSerialization() {
        switch(this.recurrenceEndType){
            case RecurrenceEndType.ByDate:
                return {
                    startDate: this.startDate.toString(),
                    recurrenceEndType: this.recurrenceEndType,
                    endDate: this.endDate.toString(),
                    countOfInstances: null
                };
            case RecurrenceEndType.ByCount:
                return {
                    startDate: this.startDate.toString(),
                    recurrenceEndType: this.recurrenceEndType,
                    endDate: null,
                    countOfInstances: this.countOfInstances
                };
            case RecurrenceEndType.EndOfPlan:
                return {
                    startDate: this.startDate.toString(),
                    recurrenceEndType: this.recurrenceEndType,
                    endDate: null,
                    countOfInstances: null
                };
            default:
                throw new Error(`Unsupported recurrence end type: ${this.recurrenceEndType}`);
        }
    }
    setStartDate(startDate) {
        return RecurrenceRange.fromResource({
            ...this.forSerialization(),
            startDate: startDate.toString()
        });
    }
    generateHash() {
        const result = [
            this.recurrenceEndType,
            this.startDate.toString()
        ];
        if (this.endDate != null) {
            result.push(this.endDate.toString());
        }
        if (this.countOfInstances != null) {
            result.push(this.countOfInstances.toString());
        }
        return result.join(",");
    }
    constructor(propertyBag){
        this.startDate = propertyBag.startDate;
        this.recurrenceEndType = propertyBag.recurrenceEndType;
        // Validate that the property combination matches the discriminated union constraints
        switch(propertyBag.recurrenceEndType){
            case RecurrenceEndType.ByDate:
                if (propertyBag.endDate === null) {
                    throw new Error(`Invalid RecurrenceRange configuration: endDate is required when recurrenceEndType is ${RecurrenceEndType.ByDate}`);
                }
                if (propertyBag.countOfInstances !== null) {
                    throw new Error(`Invalid RecurrenceRange configuration: countOfInstances must be null when recurrenceEndType is ${RecurrenceEndType.ByDate}`);
                }
                this.endDate = propertyBag.endDate;
                this.countOfInstances = null;
                break;
            case RecurrenceEndType.ByCount:
                if (propertyBag.countOfInstances === null) {
                    throw new Error(`Invalid RecurrenceRange configuration: countOfInstances is required when recurrenceEndType is ${RecurrenceEndType.ByCount}`);
                }
                if (propertyBag.endDate !== null) {
                    throw new Error(`Invalid RecurrenceRange configuration: endDate must be null when recurrenceEndType is ${RecurrenceEndType.ByCount}`);
                }
                this.endDate = null;
                this.countOfInstances = propertyBag.countOfInstances;
                break;
            case RecurrenceEndType.EndOfPlan:
                if (propertyBag.endDate !== null) {
                    throw new Error(`Invalid RecurrenceRange configuration: endDate must be null when recurrenceEndType is ${RecurrenceEndType.EndOfPlan}`);
                }
                if (propertyBag.countOfInstances !== null) {
                    throw new Error(`Invalid RecurrenceRange configuration: countOfInstances must be null when recurrenceEndType is ${RecurrenceEndType.EndOfPlan}`);
                }
                this.endDate = null;
                this.countOfInstances = null;
                break;
            default:
                throw new Error(`Unsupported recurrence end type: ${propertyBag["recurrenceEndType"]}`);
        }
    }
}
